module.exports = __webpack_public_path__ + "static/coaching-hero-b370c54bf27dd51808d1d37d82e5c3fe.jpg";